import { useMemo } from 'react';

import { getEndpointsGroup } from '../utils/getEndpointsGroup';
import { useChainSelectors } from '../components/ChainSelectorsProvider';

export const useEndpointsGroup = () => {
  const { group, isConsensusEnabled } = useChainSelectors();

  return useMemo(
    () => getEndpointsGroup({ group, isConsensusEnabled }),
    [group, isConsensusEnabled],
  );
};
